import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { ISubscription } from 'rxjs/Subscription';

import Handsontable from 'handsontable';
import { HotRegisterer } from 'angular-handsontable';
import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

@Component({
  selector: 'app-wbs-element-remarks',
  templateUrl: './wbs-element-remarks.component.html',
  styleUrls: ['./wbs-element-remarks.component.css']
})
export class WbsElementRemarksComponent implements OnInit, OnDestroy {
  columns: Array<Object>;
  report: Report;
  data: any;
  reloadSubscription: ISubscription;

  constructor(private reportService: ReportDataService, private gridContext: HotRegisterer) {
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
    this.columns = this.report.WBSElementRemarks.columns;
    this.data = this.report.WBSElementRemarks.data;
    this.reloadSubscription = this.reportService.getReload().subscribe(data => this.reload());
  }

  ngOnDestroy() {
    this.reloadSubscription.unsubscribe();
  }

  reload() {
    this.data = this.report.WBSElementRemarks.data;
    const gridInstance = this.gridContext.getInstance('WBSElementRemarks');
    gridInstance.loadData(this.data);
  }
}


// WEBPACK FOOTER //
// ./src/app/wbs-element-remarks/wbs-element-remarks.component.ts